import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";

const CONTACT = "contact@club-altitude.com";
const A = ({ href, testId, children }) => (
  <a href={href} data-testid={testId} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="font-medium text-navy underline decoration-gold-deep underline-offset-2 hover:text-gold-deep">{children}</a>
);

const SECTIONS = [
  ["editeur", "1. Éditeur du site", [
    "Le site Altitude Club est un produit et service proposé par Vikora AI LLC.",
    "Vikora AI LLC — Limited Liability Company de droit américain.",
    "État d'incorporation : Wyoming, États-Unis.",
    "Siège social : 1021 E Lincolnway, #10308, Cheyenne, WY 82001 — Laramie County, USA.",
    "Numéro EIN (Employer Identification Number) : 37-2236204.",
    <>E-mail : <A href={`mailto:${CONTACT}`} testId="legal-contact-email-link">{CONTACT}</A></>,
  ]],
  ["hebergeur", "2. Hébergeur", [
    "OVH SAS (OVHcloud), société par actions simplifiée immatriculée au RCS de Lille Métropole sous le numéro 424 761 419.",
    "Siège social : 2 rue Kellermann, 59100 Roubaix, France.",
    <>Site : <A href="https://www.ovhcloud.com" testId="legal-ovh-link">www.ovhcloud.com</A></>,
  ]],
  ["activite", "3. Activité", [
    "Altitude Club est un service d'alertes de vols en classe Business. Nous ne sommes ni une agence de voyage, ni un site de réservation : nous ne vendons pas de billets et ne prenons aucune réservation.",
    "Les tarifs et disponibilités indiqués dans nos offres proviennent de sources tierces et peuvent changer à tout moment. Ils sont confirmés uniquement par le vendeur au moment de la réservation.",
  ]],
  ["propriete", "4. Propriété intellectuelle", [
    "La marque Altitude Club, le logo, les textes, la mise en page et les éléments graphiques du site sont protégés. Toute reproduction ou réutilisation sans autorisation écrite de Vikora AI LLC est interdite.",
    "Les noms et logos des compagnies aériennes cités appartiennent à leurs propriétaires respectifs.",
  ]],
  ["responsabilite", "5. Responsabilité", [
    "Nous faisons notre possible pour fournir des informations exactes et à jour, sans pouvoir garantir l'absence d'erreur ou la disponibilité permanente du site.",
    "Les liens vers des sites tiers (compagnies, agences en ligne) sont fournis pour votre commodité : nous ne sommes pas responsables de leur contenu ni de leurs conditions de vente.",
  ]],
  ["donnees", "6. Données personnelles", [
    <>Le traitement de vos données est décrit dans notre <Link to="/confidentialite" data-testid="legal-privacy-link" className="font-medium text-navy underline decoration-gold-deep underline-offset-2 hover:text-gold-deep">politique de confidentialité</Link>.</>,
  ]],
];

const Section = ({ id, title, items }) => (
  <section data-testid={`legal-section-${id}`} className="border-t border-navy/10 pt-8">
    <h2 className="font-display text-xl text-navy sm:text-2xl">{title}</h2>
    <ul className="mt-4 space-y-3">
      {items.map((t, i) => (
        <li key={i} className="flex gap-3 text-sm leading-relaxed text-navy/75 sm:text-base">
          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-deep" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  </section>
);

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-ivory">
      <header className="flex justify-center px-5 pb-4 pt-8 sm:pt-12"><Logo tone="dark" /></header>
      <main className="mx-auto max-w-2xl px-5 pb-16 sm:px-6">
        <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy">
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
        <p className="eyebrow mt-8 text-gold-deep">Dernière mise à jour : 2 novembre 2026</p>
        <h1 data-testid="legal-title" className="mt-3 font-display text-4xl text-navy sm:text-5xl">Mentions légales</h1>
        <div className="mt-10 space-y-8">
          {SECTIONS.map(([id, title, items]) => <Section key={id} id={id} title={title} items={items} />)}
        </div>
      </main>
      <SiteFooter tone="light" />
    </div>
  );
}
